import { fetchFonts } from '@configuratorware/configurator-frontendgui/App/Reducers/Fonts/Actions';
import {
  prepareDesignDataSnapshots,
  preparePrintDesignData,
} from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Utils/SvgFixers';
import BaseConfiguratorService from '@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { get } from 'lodash';
import { selectOptionClassificationAndFetchOptions } from '../Reducers/Configurator/Actions';
import { getDefaultCanvasSize } from '../Reducers/Configurator/Selectors';
import { createInitialEditorState, type EditorState } from '../Reducers/Configurator/types';
import { DEFAULT_CANVAS_HEIGHT_MM, DEFAULT_CANVAS_WIDTH_MM } from '../utils/editorUnits';
import {
  buildEditorCanvasScreenshots,
  buildEditorElementScreenshots,
} from '../utils/buildDesignSvgExports';
import { normalizeOptionClassifications } from '../utils/optionClassifications';

export default class ConfiguratorService extends BaseConfiguratorService {
  async loadInitialConfiguration() {
    await super.loadInitialConfiguration();

    await Services.store.dispatch(fetchFonts());

    const state = Services.store.state;
    const { configuration } = get(state, 'configurator', {});
    const optionClassifications = normalizeOptionClassifications(
      get(configuration, 'optionclassifications', [])
    );

    for (const oc of optionClassifications) {
      await Services.store.dispatch(selectOptionClassificationAndFetchOptions(oc, true));
    }
  }

  async createMediaDataForConfiguration(configuration: Record<string, unknown> | undefined) {
    const mediaData = await super.createMediaDataForConfiguration(configuration);

    const state = Services.store.state;
    const editor = get(
      state,
      'configurator.configuration.customdata.editor',
      createInitialEditorState()
    ) as EditorState;
    const canvasSize = getDefaultCanvasSize(state);
    const svgContext = {
      canvasWidthMm: canvasSize.width || DEFAULT_CANVAS_WIDTH_MM,
      canvasHeightMm: canvasSize.height || DEFAULT_CANVAS_HEIGHT_MM,
    };

    const elementSvgs = buildEditorElementScreenshots(editor, svgContext);
    if (Object.keys(elementSvgs).length > 0) {
      mediaData.designDataSnapshots = prepareDesignDataSnapshots(elementSvgs);
    }

    const canvasSvgs = buildEditorCanvasScreenshots(editor, svgContext);
    if (Object.keys(canvasSvgs).length > 0) {
      mediaData.printDesignData = preparePrintDesignData(canvasSvgs);
    }

    if (typeof configuration === 'object') {
      Object.assign(configuration, {
        designDataSnapshots: mediaData.designDataSnapshots,
        printDesignData: mediaData.printDesignData,
      });
    }

    return mediaData;
  }
}
